import { IClientAddress } from '../models/Unit'

export const getAddressFilterValues = (addresses: IClientAddress[]) => {
  const values: { displayText: string; id: string | undefined }[] = [
    { displayText: 'Alle adresser', id: undefined },
  ]

  addresses.forEach((x) =>
    values.push({ displayText: x.address, id: x.addressId?.toString() })
  )

  return values
}
